module.exports = __webpack_public_path__ + "img/emilio-munaro.360be318.jpg";